import moment from "moment";
import { Input } from "reactstrap";
import React, { useEffect } from "react";
import { Tooltip } from "@mui/material";

import CustomButton from "components/CustomButton";
import { ReactComponent as ActiveControl } from "assets/img/svg/ActiveControl.svg";
import { ReactComponent as InactiveControl } from "assets/img/svg/InactiveControl.svg";

import AChip from "../../common/chip/AChip";
import NoRowOverlay from "../holidayMaster/NoRowOverlay";
import ADataGrid from "../../common/data-grid/ADataGrid";
import { AGridColDef } from "../../common/data-grid/ADataGridColDef";
import CommonInput from "../../common/formFeilds/input/commonInput";
import { failureToast } from "../../common/utils/methods/toasterFunctions/function";
import { capitalize } from "../../common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";

import { editCellContainerStyle } from "../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import {
  gridStyles,
  gridComponents,
} from "../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import {
  getLabelById,
  getValueById,
  isObjEmpty,
  AAutoCompleteCustomStyles,
} from "./constants";

const PincodeTableContent = ({
  rowData,
  rowForm,
  setRowForm,
  userPermissions,
  countryList,
  stateList,
  allStateList,
  updateStateOptions,
  allDistrictList,
  districtList,
  updateDistrictOptions,
  allCityList,
  cityList,
  updateCityOptions,
  saveAll,
  pagination,
  deleteRow,
  onPageChange,
  loader,
  rowModesModel,
  startEditing,
  handleCancelClick,
}) => {
  useEffect(() => {
    if (rowForm?.countryId) updateStateOptions(rowForm?.countryId);
  }, [rowForm?.countryId]);

  useEffect(() => {
    if (rowForm?.stateId) updateDistrictOptions(rowForm?.stateId);
  }, [rowForm?.stateId]);

  useEffect(() => {
    if (rowForm?.districtId) updateCityOptions(rowForm?.districtId);
  }, [rowForm?.districtId]);

  const formattedDateTime = (timestamp) =>
    moment(timestamp).format("DD/MM/YYYY");

  const rowFormHandler = (value, key) => {
    setRowForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast("Please Delete or Save current changes");
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const columns = [
    new AGridColDef("countryId", "Country")
      .setMinWidth(100)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) => getLabelById(countryList, params.value))
      .renderEditCellComponent((params) => {
        return (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              placeholder="Select"
              items={countryList}
              currentValue={getValueById(countryList, rowForm?.countryId)}
              handleChange={(value) => {
                rowFormHandler(value?.value, "countryId");
                rowFormHandler("", "stateId");
                rowFormHandler("", "districtId");
                rowFormHandler("", "cityId");
              }}
              inputKey="country"
              {...AAutoCompleteCustomStyles}
            />
          </div>
        );
      }),

    new AGridColDef("stateId", "State")
      .setMinWidth(150)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) => getLabelById(allStateList, params.value))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            //   label="State"
            placeholder="Select"
            items={stateList}
            currentValue={getValueById(stateList, rowForm?.stateId)}
            handleChange={(value) => {
              rowFormHandler(value?.value, "stateId");
              rowFormHandler("", "districtId");
              rowFormHandler("", "cityId");
            }}
            inputKey="state"
            isDisabled={!rowForm?.countryId}
            {...AAutoCompleteCustomStyles}
          />
        </div>
      )),

    new AGridColDef("districtId", "District")
      .setMinWidth(150)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) =>
        getLabelById(allDistrictList, params.value)
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            //   label="District"
            placeholder="Select"
            items={districtList}
            currentValue={getValueById(districtList, rowForm?.districtId)}
            handleChange={(value) => {
              rowFormHandler(value?.value, "districtId");
              rowFormHandler("", "cityId");
            }}
            inputKey="district"
            isDisabled={!rowForm?.stateId}
            {...AAutoCompleteCustomStyles}
          />
        </div>
      )),

    new AGridColDef("cityId", "City")
      .setMinWidth(150)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) => getLabelById(allCityList, params.value))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            //   label="City"
            placeholder="Select"
            items={cityList}
            currentValue={getValueById(cityList, rowForm?.cityId)}
            handleChange={(value) => {
              rowFormHandler(value?.value, "cityId");
            }}
            inputKey="city"
            isDisabled={!rowForm?.districtId}
            {...AAutoCompleteCustomStyles}
          />
        </div>
      )),

    new AGridColDef("pincodeGstCode", "Pincode")
      .setMinWidth(100)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) => params?.value || "-")
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <CommonInput
            type={"number"}
            maxLength={"6"}
            forTable={true}
            restrictSpecialCharacter={true}
            defaultValue={rowForm?.pincodeGstCode}
            placeHolder={"Pincode"}
            className={"tdInput"}
            onChange={(value) => {
              rowFormHandler(value, "pincodeGstCode");
            }}
            height="31px"
          />
        </div>
      )),

    new AGridColDef("pincodeDesc", "Description")
      .setMinWidth(150)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      )
      .renderEditCellComponent((params) => {
        return (
          <div style={editCellContainerStyle}>
            <Input
              maxLength="50"
              defaultValue={rowForm?.pincodeDesc}
              onChange={(e) => {
                rowFormHandler(e.target.value, "pincodeDesc");
              }}
              placeholder="Description"
              className="tdInput"
            />
          </div>
        );
      }),

    new AGridColDef("pincodeDispValue", "Display Value")
      .setMinWidth(80)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <Input
            maxLength="50"
            defaultValue={rowForm?.pincodeDispValue}
            onChange={(e) => {
              rowFormHandler(e.target.value, "pincodeDispValue");
            }}
            placeholder="Display Value"
            className="tdInput"
          />
        </div>
      )),

    new AGridColDef("salesforceId", "Salesforce ID")
      .setMinWidth(180)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(false)
      .renderCellComponent((params) => params?.value || "-"),

    new AGridColDef("websiteId", "Website ID")
      .setMinWidth(100)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(false)
      .renderCellComponent((params) => params?.value || "-"),

    new AGridColDef("effectiveDate", "Effective Date")
      .setMinWidth(100)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(false)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={formattedDateTime(params?.value)}>
            <div className="ellipsis-text-container">
              {formattedDateTime(params?.value)}
            </div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("createdOn", "Created On")
      .setMinWidth(90)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(false)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={formattedDateTime(params?.value)}>
            <div className="ellipsis-text-container">
              {formattedDateTime(params?.value)}
            </div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("updatedBy", "Updated By")
      .setMinWidth(100)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(false)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("status", "Status")
      .setMinWidth(120)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) => (
        <AChip
          label={capitalize(params?.value)}
          success={params.value === "ACTIVE"}
        />
      ))
      .renderEditCellComponent((params) => {
        return (
          <div style={editCellContainerStyle}>
            <span>
              {rowForm?.status === "ACTIVE" ? (
                <ActiveControl
                  onClick={() => rowFormHandler("INACTIVE", "status")}
                />
              ) : (
                <InactiveControl
                  onClick={() => rowFormHandler("ACTIVE", "status")}
                />
              )}
              <span className="ml-1">Active</span>
            </span>
          </div>
        );
      }),

    new AGridColDef("actions", "Action", false)
      .setMinWidth(140)
      .setFlex(0.5)
      .pinColumnLast(true)
      .renderCellComponent((params) =>
        params.api.getRowMode(params?.id) === "view" ? (
          <>
            <CustomButton
              content={""}
              permissionType={"U"}
              icon={true}
              forTable={true}
              onClick={() => {
                handleEditClick(params);
              }}
              permissionSet={userPermissions}
            />

            <CustomButton
              content={""}
              permissionType={"D"}
              icon={true}
              forTable={true}
              onClick={() => {
                deleteRow(params.id);
              }}
              permissionSet={userPermissions} //todo: for SuperAdmins only
            />
          </>
        ) : (
          <>
            <CustomButton
              content={"Save"}
              permissionType={"C,U"}
              icon={false}
              forTable={true}
              onClick={() => {
                // stopEditing(rowId);
                saveAll(params.row.id);
              }}
              permissionSet={userPermissions}
            />
            <CustomButton
              content={""}
              permissionType={"cancel"}
              icon={true}
              forTable={true}
              onClick={() => {
                handleCancelClick(params);
              }}
              permissionSet={userPermissions}
            />
          </>
        )
      ),
  ];

  return (
    <div className="mt-3">
      <ADataGrid
        removeWrapperContainer
        rowModesModel={rowModesModel}
        rows={rowData || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={false}
        rowCount={pagination?.totalRecords}
        nextButtonHandler={onPageChange}
        currentPage={pagination?.currentPage}
        components={{
          ...gridComponents,
          NoRowsOverlay: () => (
            <NoRowOverlay message={loader ? "Loading..." : null} />
          ),
        }}
        sx={gridStyles}
        autoHeight
        pinLastColumn
      />
    </div>
  );
};

export default PincodeTableContent;
